import { useSyncExternalStore } from 'react';

const MINUTE = 60_000;
const listeners = new Set<() => void>();
let now = Date.now();
let timer: ReturnType<typeof setTimeout> | undefined;

const getSnapshot = () => {
	const current = Date.now();
	if (Math.floor(current / MINUTE) !== Math.floor(now / MINUTE)) {
		now = current;
	}
	return now;
};

const scheduleTick = () => {
	timer = setTimeout(() => {
		scheduleTick();
		listeners.forEach(listener => listener());
	}, MINUTE - (Date.now() % MINUTE));
};

const subscribe = (listener: () => void) => {
	if (!listeners.size) {
		scheduleTick();
	}
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
		if (!listeners.size) {
			clearTimeout(timer);
		}
	};
};

// Epoch ms, refreshed once per wall-clock minute; every mounted caller shares one timer.
const useNow = () => useSyncExternalStore(subscribe, getSnapshot);

export default useNow;
